import styles from './segment.scss?inline';
import slotStyles from './segment.slot.scss?inline';
import { LitElement, unsafeCSS, CSSResult } from 'lit';
import { literal, html } from 'lit/static-html.js';
import { C11nPrefix, C11nPrefixLiteral } from 'virtual:c11n-prefix';
import { appendStylesheet, c11nElement } from '../core';
import { property } from 'lit/decorators.js';

@c11nElement()
export class SegmentComponent extends LitElement {

  static selector = `${C11nPrefix}-segment`;
  static literal = literal`${C11nPrefixLiteral}-segment`;
  static override styles: CSSResult = unsafeCSS(styles);

  @property({ attribute: 'c11n-web-segment', type: Boolean, reflect: true })
  readonly _c11n_web_segment: boolean = true;

  override connectedCallback(): void {
    super.connectedCallback();
    this.appendStyles();
  }

  appendStyles() {
    const slotStylesheet: string = slotStyles.toString()
      .replaceAll(/\bc11n-web-segment\b/g, this.tagName.toLowerCase());
    appendStylesheet({ 
      target: this, 
      styles: slotStylesheet, 
      name: `${this.tagName.toLowerCase()}-slot`
    });
  }

  override render() {
    return html`
      <slot></slot>
    `;
  }
}
export const C11nSegment = SegmentComponent.selector;
export const C11nSegmentLiteral = SegmentComponent.literal;
